import { render, staticRenderFns } from "./freight.vue?vue&type=template&id=74db3fe5&scoped=true&"
import script from "./freight.vue?vue&type=script&lang=js&"
export * from "./freight.vue?vue&type=script&lang=js&"
import style0 from "./freight.vue?vue&type=style&index=0&id=74db3fe5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74db3fe5",
  null
  
)

export default component.exports